import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { Observable } from 'rxjs';

@Component({
    selector: 'usimweb-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    standalone: false
})
export class SearchbarComponent implements OnInit {
  @Output() searchBarChanged: EventEmitter<string> = new EventEmitter<string>();

  public seachControl = new UntypedFormControl();
  public filter$: Observable<string[]> = new Observable();

  constructor() {}

  ngOnInit(): void {
    this.seachControl.setValue('');
  }

  private emit() {
    this.searchBarChanged.emit(this.seachControl.getRawValue());
  }

  public searchChangedEvent() {
    this.emit();
  }

  public optionClicked(event: HTMLInputElement) {
    this.seachControl.setValue(event.value);
    this.emit();
  }

  public clearInput() {
    this.seachControl.setValue('');
    this.emit();
  }
}
